import { render, staticRenderFns } from "./registry-organization-information.html?vue&type=template&id=a7987dfe&"
import script from "./RegistryOrganizationInformation.vue?vue&type=script&lang=js&"
export * from "./RegistryOrganizationInformation.vue?vue&type=script&lang=js&"
import style0 from "./RegistryOrganizationInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports